export const CHANGE_AUTH_FORM = 'CHANGE_AUTH_FORM'
export const SET_AUTH = 'SET_AUTH'
export const SENDING_AUTH_REQUEST = 'SENDING_AUTH_REQUEST'
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const LOGOUT = 'LOGOUT'
export const REQUEST_AUTH_ERROR = 'REQUEST_AUTH_ERROR'
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR'
export const SET_UNAUTHORIZED = 'SET_UNAUTHORIZED'

export const SENDING_FORGOT_PASSWORD_REQUEST = 'SENDING_FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'

export const SENDING_VERIFY_CODE_RESET_PASSWORD_REQUEST = 'SENDING_VERIFY_CODE_RESET_PASSWORD_REQUEST'
export const VERIFY_CODE_RESET_PASSWORD_REQUEST = 'VERIFY_CODE_RESET_PASSWORD_REQUEST'
export const VERIFY_CODE_RESET_PASSWORD_SUCCESS = 'VERIFY_CODE_RESET_PASSWORD_SUCCESS'
export const VERIFY_CODE_RESET_PASSWORD_FAILURE = 'VERIFY_CODE_RESET_PASSWORD_FAILURE'

export const SENDING_RESET_PASSWORD_REQUEST = 'SENDING_RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

export const SET_USER = 'SET_USER'
export const SET_SYSTEM = 'SET_SYSTEM'
export const SET_STATION = 'SET_STATION'

export const USER_CLEAR_ERROR = 'USER_CLEAR_ERROR'
export const SENDING_USER_CHANGE_PASSWORD = 'SENDING_USER_CHANGE_PASSWORD'
export const USER_CHANGE_PASSWORD_REQUEST = 'USER_CHANGE_PASSWORD_REQUEST'
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS'
export const USER_CHANGE_PASSWORD_FAILURE = 'USER_CHANGE_PASSWORD_FAILURE'

export const SENDING_ALL_SYSTEM_REQUEST = 'SENDING_ALL_SYSTEM_REQUEST'
export const FETCH_ALL_SYSTEM_REQUEST = 'FETCH_ALL_SYSTEM_REQUEST'
export const FETCH_ALL_SYSTEM_SUCCESS = 'FETCH_ALL_SYSTEM_SUCCESS'
export const FETCH_ALL_SYSTEM_FAILURE = 'FETCH_ALL_SYSTEM_FAILURE'

export const SENDING_HUBS_REQUEST = 'SENDING_HUBS_REQUEST'
export const FETCH_HUBS_REQUEST = 'FETCH_HUBS_REQUEST'
export const FETCH_HUBS_SUCCESS = 'FETCH_HUBS_SUCCESS'
export const FETCH_HUBS_FAILURE = 'FETCH_HUBS_FAILURE'

export const SENDING_HUB_CREATE = 'SENDING_HUB_CREATE'
export const CREATE_HUB_REQUEST = 'CREATE_HUB_REQUEST'
export const CREATE_HUB_SUCCESS = 'CREATE_HUB_SUCCESS'
export const CREATE_HUB_FAILURE = 'CREATE_HUB_FAILURE'

export const SENDING_HUB_UPDATE = 'SENDING_HUB_UPDATE'
export const UPDATE_HUB_REQUEST = 'UPDATE_HUB_REQUEST'
export const UPDATE_HUB_SUCCESS = 'UPDATE_HUB_SUCCESS'
export const UPDATE_HUB_FAILURE = 'UPDATE_HUB_FAILURE'

export const SENDING_HUB_DELETE = 'SENDING_HUB_DELETE'
export const DELETE_HUB_REQUEST = 'DELETE_HUB_REQUEST'
export const DELETE_HUB_SUCCESS = 'DELETE_HUB_SUCCESS'
export const DELETE_HUB_FAILURE = 'DELETE_HUB_FAILURE'

export const SENDING_HUB_UPLOAD = 'SENDING_HUB_UPLOAD'
export const UPLOAD_HUB_REQUEST = 'UPLOAD_HUB_REQUEST'
export const UPLOAD_HUB_SUCCESS = 'UPLOAD_HUB_SUCCESS'
export const UPLOAD_HUB_FAILURE = 'UPLOAD_HUB_FAILURE'

export const SENDING_HUB_UPGRADE = 'SENDING_HUB_UPGRADE'
export const UPGRADE_HUB_REQUEST = 'UPGRADE_HUB_REQUEST'
export const UPGRADE_HUB_SUCCESS = 'UPGRADE_HUB_SUCCESS'
export const UPGRADE_HUB_FAILURE = 'UPGRADE_HUB_FAILURE'

export const SENDING_ACCOUNT_REGISTER = 'SENDING_ACCOUNT_REGISTER'
export const REGISTER_ACCOUNT_REQUEST = 'REGISTER_ACCOUNT_REQUEST'
export const REGISTER_ACCOUNT_SUCCESS = 'REGISTER_ACCOUNT_SUCCESS'
export const REGISTER_ACCOUNT_FAILURE = 'REGISTER_ACCOUNT_FAILURE'

export const SENDING_PRESENTATION_REQUEST = 'SENDING_PRESENTATION_REQUEST'
export const FETCH_PRESENTATION_REQUEST = 'FETCH_PRESENTATION_REQUEST'
export const FECTH_PRESENTATION_SUCCESS = 'FECTH_PRESENTATION_SUCCESS'
export const FECTH_PRESENTATION_FAILURE = 'FECTH_PRESENTATION_FAILURE'
export const FILTER_PRESENTATION_GROUPS = 'FILTER_PRESENTATION_GROUPS'
export const MQTT_NEW_STATTION_STATE_RECEIVE = 'MQTT_NEW_STATTION_STATE_RECEIVE'

export const SENDING_PRESENTATION_STATION_REQUEST = 'SENDING_PRESENTATION_STATION_REQUEST'
export const FETCH_PRESENTATION_STATION_REQUEST = 'FETCH_PRESENTATION_STATION_REQUEST'
export const FETCH_PRESENTATION_STATION_SUCCESS = 'FECTH_PRESENTATION_STATION_SUCCESS'
export const FETCH_PRESENTATION_STATION_FAILURE = 'FETCH_PRESENTATION_STATION_FAILURE'

export const SENDING_DEVICE_STATUS_REQUEST = 'SENDING_DEVICE_STATUS_REQUEST'
export const FETCH_DEVICE_STATUS_REQUEST = 'FETCH_DEVICE_STATUS_REQUEST'
export const FECTH_DEVICE_STATUS_SUCCESS = 'FECTH_DEVICE_STATUS_SUCCESS'
export const FECTH_DEVICE_STATUS_FAILURE = 'FECTH_DEVICE_STATUS_FAILURE'
export const DEVICE_STATUS_UPDATED = 'DEVICE_STATUS_UPDATED'

export const SENDING_STATION_CONFIG_REQUEST = 'SENDING_STATION_CONFIG_REQUEST'
export const FETCH_STATION_CONFIG_REQUEST = 'FETCH_STATION_CONFIG_REQUEST'
export const FECTH_STATION_CONFIG_SUCCESS = 'FECTH_STATION_CONFIG_SUCCESS'
export const FECTH_STATION_CONFIG_FAILURE = 'FECTH_STATION_CONFIG_FAILURE'

export const SENDING_RECENT_EVENT_REQUEST = 'SENDING_RECENT_EVENT_REQUEST'
export const FETCH_RECENT_EVENT_REQUEST = 'FETCH_RECENT_EVENT_REQUEST'
export const FECTH_RECENT_EVENT_SUCCESS = 'FECTH_RECENT_EVENT_SUCCESS'
export const FECTH_RECENT_EVENT_FAILURE = 'FECTH_RECENT_EVENT_FAILURE'
export const NEW_EVENTS_UPDATED = 'NEW_EVENTS_UPDATED'

export const MQTT_INITIALIZE = 'MQTT_INITIALIZE'
export const MQTT_CONNECTED = 'MQTT_CONNECTED'
export const MQTT_OFFILNE = 'MQTT_OFFILNE'
export const MQTT_RECONNECT = 'MQTT_RECONNECT'
export const MQTT_CLOSE = 'MQTT_CLOSE'
export const MQTT_SUBCRIBE_TOPIC = 'MQTT_SUBCRIBE_TOPIC'
export const MQTT_UNSUBCRIBE_TOPIC = 'MQTT_UNSUBCRIBE_TOPIC'
export const MQTT_MESSAGE_RECEIVED = 'MQTT_MESSAGE_RECEIVED'
export const MQTT_DEVICE_STATUS_RECEIVED = 'MQTT_DEVICE_STATUS_RECEIVED'
export const MQTT_NEW_EVENT_RECEIVED = 'MQTT_NEW_EVENT_RECEIVED'
export const MQTT_NEW_CONFIG_RECEIVED = 'MQTT_NEW_CONFIG_RECEIVED'
export const MQTT_NEW_ALARM_STATE_RECEIVE = 'MQTT_NEW_ALARM_STATE_RECEIVE'
export const MQTT_STATION_CONNECTION_STATUS_RECEIVE = 'MQTT_STATION_CONNECTION_STATUS_RECEIVE'

export const SENDING_DEVICE_COMMAND_REQUEST = 'SENDING_DEVICE_COMMAND_REQUEST'
export const POST_DEVICE_COMMAND_REQUEST = 'POST_DEVICE_COMMAND_REQUEST'
export const POST_DEVICE_COMMAND_SUCCESS = 'POST_DEVICE_COMMAND_SUCCESS'
export const POST_DEVICE_COMMAND_FAILURE = 'POST_DEVICE_COMMAND_FAILURE'

export const SENDING_REBOOT_REQUEST = 'SENDING_REBOOT_REQUEST'
export const POST_REBOOT_REQUEST = 'POST_REBOOT_REQUEST'
export const POST_REBOOT_SUCCESS = 'POST_REBOOT_SUCCESS'
export const POST_REBOOT_FAILURE = 'POST_REBOOT_FAILURE'

export const SENDING_SYNC_REQUEST = 'SENDING_REBOOT_REQUEST'
export const POST_SYNC_REQUEST = 'POST_SYNC_REQUEST'
export const POST_SYNC_SUCCESS = 'POST_SYNC_SUCCESS'
export const POST_SYNC_FAILURE = 'POST_SYNC_FAILURE'

export const SENDING_CAMERAS_REQUEST = 'SENDING_CAMERAS_REQUEST'
export const FETCH_CAMERAS_REQUEST = 'FETCH_CAMERAS_REQUEST'
export const FETCH_CAMERAS_SUCCESS = 'FETCH_CAMERAS_SUCCESS'
export const FETCH_CAMERAS_FAILURE = 'FETCH_CAMERAS_FAILURE'

export const SENDING_CAMERAS_BY_PERMISSION_REQUEST = 'SENDING_CAMERAS_BY_PERMISSION_REQUEST'
export const FETCH_CAMERAS_BY_PERMISSION_REQUEST = 'FETCH_CAMERAS_BY_PERMISSION_REQUEST'
export const FETCH_CAMERAS_BY_PERMISSION_SUCCESS = 'FETCH_CAMERAS_BY_PERMISSION_SUCCESS'
export const FETCH_CAMERAS_BY_PERMISSION_FAILURE = 'FETCH_CAMERAS_BY_PERMISSION_FAILURE'

export const FETCH_CAMERA_CATEGORIES_SUCCESS = 'FETCH_CAMERA_CATEGORIES_SUCCESS'
export const FETCH_CAMERA_CATEGORIES_FAILURE = 'FETCH_CAMERA_CATEGORIES_FAILURE'

export const SENDING_CAMERA_CREATE = 'SENDING_CAMERA_CREATE'
export const CREATE_CAMERA_REQUEST = 'CREATE_CAMERA_REQUEST'
export const CREATE_CAMERA_SUCCESS = 'CREATE_CAMERA_SUCCESS'
export const CREATE_CAMERA_FAILURE = 'CREATE_CAMERA_FAILURE'

export const SENDING_CAMERA_UPDATE = 'SENDING_CAMERA_UPDATE'
export const UPDATE_CAMERA_REQUEST = 'UPDATE_CAMERA_REQUEST'
export const UPDATE_CAMERA_SUCCESS = 'UPDATE_CAMERA_SUCCESS'
export const UPDATE_CAMERA_FAILURE = 'UPDATE_CAMERA_FAILURE'

export const SENDING_CAMERA_DELETE = 'SENDING_CAMERA_DELETE'
export const DELETE_CAMERA_REQUEST = 'DELETE_CAMERA_REQUEST'
export const DELETE_CAMERA_SUCCESS = 'DELETE_CAMERA_SUCCESS'
export const DELETE_CAMERA_FAILURE = 'DELETE_CAMERA_FAILURE'

export const SENDING_STATIONS_REQUEST = 'SENDING_STATIONS_REQUEST'
export const FETCH_STATIONS_REQUEST = 'FETCH_STATIONS_REQUEST'
export const FETCH_STATIONS_SUCCESS = 'FETCH_STATIONS_SUCCESS'
export const FETCH_STATIONS_FAILURE = 'FETCH_STATIONS_FAILURE'

export const SENDING_STATION_UPDATE = 'SENDING_STATION_UPDATE'
export const UPDATE_STATION_REQUEST = 'UPDATE_STATION_REQUEST'
export const UPDATE_STATION_SUCCESS = 'UPDATE_STATION_SUCCESS'
export const UPDATE_STATION_FAILURE = 'UPDATE_STATION_FAILURE'

export const SENDING_STATION_DELETE = 'SENDING_STATION_DELETE'
export const DELETE_STATION_REQUEST = 'DELETE_STATION_REQUEST'
export const DELETE_STATION_SUCCESS = 'DELETE_STATION_SUCCESS'
export const DELETE_STATION_FAILURE = 'DELETE_STATION_FAILURE'

export const SENDING_GROUPS_REQUEST = 'SENDING_GROUPS_REQUEST'
export const FETCH_GROUPS_REQUEST = 'FETCH_GROUPS_REQUEST'
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS'
export const FETCH_GROUPS_FAILURE = 'FETCH_GROUPS_FAILURE'

export const SENDING_GROUP_CREATE = 'SENDING_GROUP_CREATE'
export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST'
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS'
export const CREATE_GROUP_FAILURE = 'CREATE_GROUP_FAILURE'

export const SENDING_GROUP_UPDATE = 'SENDING_GROUP_UPDATE'
export const UPDATE_GROUP_REQUEST = 'UPDATE_GROUP_REQUEST'
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS'
export const UPDATE_GROUP_FAILURE = 'UPDATE_GROUP_FAILURE'

export const SENDING_GROUP_DELETE = 'SENDING_GROUP_DELETE'
export const DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST'
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS'
export const DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE'

export const SENDING_ACCOUNTS_REQUEST = 'SENDING_ACCOUNTS_REQUEST'
export const FETCH_ACCOUNTS_REQUEST = 'FETCH_ACCOUNTS_REQUEST'
export const FETCH_ACCOUNTS_SUCCESS = 'FETCH_ACCOUNTS_SUCCESS'
export const FETCH_ACCOUNTS_FAILURE = 'FETCH_ACCOUNTS_FAILURE'

export const SENDING_ACCOUNT_UPDATE = 'SENDING_ACCOUNT_UPDATE'
export const UPDATE_ACCOUNT_REQUEST = 'UPDATE_ACCOUNT_REQUEST'
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS'
export const UPDATE_ACCOUNT_FAILURE = 'UPDATE_ACCOUNT_FAILURE'

export const SENDING_ACCOUNT_UPDATE_PERMISSION = 'SENDING_ACCOUNT_UPDATE_PERMISSION'
export const UPDATE_ACCOUNT_PERMISSION_REQUEST = 'UPDATE_ACCOUNT_PERMISSION_REQUEST'
export const UPDATE_ACCOUNT_PERMISSION_SUCCESS = 'UPDATE_ACCOUNT_PERMISSION_SUCCESS'
export const UPDATE_ACCOUNT_PERMISSION_FAILURE = 'UPDATE_ACCOUNT_PERMISSION_FAILURE'

export const SENDING_ACCOUNT_DELETE = 'SENDING_ACCOUNT_DELETE'
export const DELETE_ACCOUNT_REQUEST = 'DELETE_ACCOUNT_REQUEST'
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS'
export const DELETE_ACCOUNT_FAILURE = 'DELETE_ACCOUNT_FAILURE'

export const SENDING_PERMISSIONS_REQUEST = 'SENDING_PERMISSIONS_REQUEST'
export const FETCH_PERMISSIONS_REQUEST = 'FETCH_PERMISSIONS_REQUEST'
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS'
export const FETCH_PERMISSIONS_FAILURE = 'FETCH_PERMISSIONS_FAILURE'

export const SENDING_CHART_DEVICE_DATA_REQUEST = 'SENDING_CHART_DEVICE_DATA_REQUEST'
export const FETCH_CHART_DEVICE_DATA_REQUEST = 'FETCH_CHART_DEVICE_DATA_REQUEST'
export const FETCH_CHART_DEVICE_DATA_SUCCESS = 'FETCH_CHART_DEVICE_DATA_SUCCESS'
export const FETCH_CHART_DEVICE_DATA_FAILURE = 'FETCH_CHART_DEVICE_DATA_FAILURE'

export const SENDING_TIME_LINE_DEVICE_DATA_REQUEST = 'SENDING_TIME_LINE_DEVICE_DATA_REQUEST'
export const FETCH_TIME_LINE_DEVICE_DATA_REQUEST = 'FETCH_TIME_LINE_DEVICE_DATA_REQUEST'
export const FETCH_TIME_LINE_DEVICE_DATA_SUCCESS = 'FETCH_TIME_LINE_DEVICE_DATA_SUCCESS'
export const FETCH_TIME_LINE_DEVICE_DATA_FAILURE = 'FETCH_TIME_LINE_DEVICE_DATA_FAILURE'

export const SENDING_POWER_METER_DAY_DATA_REQUEST = 'SENDING_POWER_METER_DAY_DATA_REQUEST'
export const FETCH_POWER_METER_DAY_DATA_REQUEST = 'FETCH_POWER_METER_DAY_DATA_REQUEST'
export const FETCH_POWER_METER_DAY_DATA_SUCCESS = 'FETCH_POWER_METER_DAY_DATA_SUCCESS'
export const FETCH_POWER_METER_DAY_DATA_FAILURE = 'FETCH_POWER_METER_DAY_DATA_FAILURE'

export const SENDING_POWER_METER_MONTH_DATA_REQUEST = 'SENDING_POWER_METER_MONTH_DATA_REQUEST'
export const FETCH_POWER_METER_MONTH_DATA_REQUEST = 'FETCH_POWER_METER_MONTH_DATA_REQUEST'
export const FETCH_POWER_METER_MONTH_DATA_SUCCESS = 'FETCH_POWER_METER_MONTH_DATA_SUCCESS'
export const FETCH_POWER_METER_MONTH_DATA_FAILURE = 'FETCH_POWER_METER_MONTH_DATA_FAILURE'

export const EXPORT_DEVICE_DATA_REQUEST = 'EXPORT_DEVICE_DATA_REQUEST'
export const EXPORT_DEVICE_DATA_FAILURE = 'EXPORT_DEVICE_DATA_FAILURE'



// WEBPACK FOOTER //
// ./src/actions/constants.js